<!-- 推荐使用grid-table-td替代 -->
<template>
  <li class="main-table-cell main-table-cell-medium">
    <div class="main-table-cell-wrap">
      <span class="main-table-txt" style="color: #677de0; cursor: pointer;">
        <slot></slot>
      </span>
    </div>
  </li>
</template>
<script>
  export default {
    name: 'grid-common-menu'
  }
</script>



// WEBPACK FOOTER //
// src/components/grid-menu/grid-common-menu.vue